import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Page from '../../../../page/index';
import SolutionHeader from '../../../SolutionHeader/SolutionHeader';
import { setScreen } from '../../../../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../../../../config/uiFactory.config';
import {MIStepper} from './MIStepper';
import {resetState} from '../../../../../redux/connectedComponent/ManageIntegrationsV2/ManageIntegrationsV2.slice';
import {resetConfigurations} from '../../../../../redux/connectedComponent/configurations/Configurations.slice';
import { clearState } from "../../../../../redux/connectedComponent/manageBulkConnections/manageBulkConnectioins.slice";
import { resetConsentLink } from "../../../../../redux/connectedComponent/solutionInfo/solutionInfo.slice";
import {resetState as resetAPIIntegrationsState} from "../../../../../redux/connectedComponent/apiIntegrations/apiIntegration.slice";
import { getApiIntegrationsDetails } from "../../../../../redux/connectedComponent/apiIntegrations/apiIntegration.slice";
import { Loader } from 'cdk-radial';
import '../apiinfocell.scss';

const LandingPage = ({
    solutionData,
    additionalData,
  }) => {
    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const {
        displayName,
        orgName,
        isAppNotListed,
    } = solutionData;
    const {subscriptionData, apiDetails, isNewApi} = additionalData;
    const { authenticationToken } = state.loginDetailsSlice;
    const { isApiIntegrationsDetailsPending } = state.apiIntegrationSlice;

    const onBack = () => {
        const {selectedPlanId, isBulkSubscribed} = additionalData;
        dispatch(resetConfigurations());
        dispatch(resetConsentLink());
        dispatch(resetState());
        dispatch(clearState());
        dispatch(resetAPIIntegrationsState());
        dispatch(setScreen({
          screen: screens.MANAGE_INTEGRATION,
          solutionData,
          additionalData: {
            isAppNotListed,
            subscriptionData,
            selectedPlanId,
            isBulkSubscribed
          },
        }));
    };

    useEffect(() => {
      const {
        isBulkSubscribed,
        apiDetails: { id, apiType },
      } = additionalData;
      const solutionId = solutionData.id;
      const entities = subscriptionData.map(
        (dealer) => dealer.entityId
      );
      let payload = {
        entities, 
        solutionId,
        isBulkSubscribed: isBulkSubscribed
      }
      if (isBulkSubscribed && apiType === 'async-api') {
        let entityIdSubscriptionIdMapping = subscriptionData.map(data => ({
          entityId: data.entityId,
          subscriptionId: data.subscriptionId
        }));
  
        payload = {
          ...payload,
          apiId: id,
          apiType,
          entityIdSubscriptionIdMapping,
          asyncIntegrationId: solutionData?.registration_details?.api_details?.filter(api => api?.id === id)?.[0]?.asyncIntegrationId
        }
      }
      if(isBulkSubscribed){
        dispatch(getApiIntegrationsDetails({payload,token: authenticationToken}));
      }
    }, [])

    return (
      <Page>
        <SolutionHeader
          solutionData={solutionData}
          isAppNotListed={isAppNotListed}
          appName={displayName}
          publisherName={orgName}
          onBackButtonClickHandler={onBack}
          text="Back to Integrations"
        />
        {isApiIntegrationsDetailsPending ? (
          <Loader className="integration_details_loader" label={'Fetching integration details...'}/>
        ) : (
          <MIStepper
            solutionData={solutionData}
            additionalData={additionalData}
            apiDetails={apiDetails}
            subscriptionData={subscriptionData}
            isNewApi={isNewApi}
          />
        )}
      </Page>
    );
};

export default LandingPage;